import { useEffect, useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ProgettoCard from "@/components/ProgettoCard";
import ProgettoLightbox from "@/components/ProgettoLightbox";
import { listProgetti } from "@/lib/api";

const TEASER_COUNT = 6;

export default function GallerySection() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    listProgetti()
      .then((data) => setItems(data.slice(0, TEASER_COUNT)))
      .catch((err) => console.error("Errore caricamento progetti:", err))
      .finally(() => setLoading(false));
  }, []);

  if (!loading && items.length === 0) return null;

  return (
    <section id="galleria" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <p className="text-sm font-bold uppercase tracking-[0.2em] bg-clip-text text-transparent bg-gradient-to-r from-orange-500 via-blue-500 to-purple-500 mb-4">
            I Nostri Lavori
          </p>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#0B1E36] mb-6">
            Alcune delle Nostre Installazioni
          </h2>
          <p className="text-base md:text-lg text-[#64748B] leading-relaxed">
            Un'anteprima dei nostri progetti recenti. Esplora la galleria
            completa per vedere tutte le realizzazioni.
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-[#0B1E36]" />
          </div>
        ) : (
          <>
            {/* Grid stesso layout di /progetti */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12 md:mb-16">
              {items.map((project, index) => (
                <ProgettoCard
                  key={project.id ?? index}
                  project={project}
                  onClick={() => setSelected(project)}
                  testId={`gallery-item-${index}`}
                />
              ))}
            </div>

            {/* CTA */}
            <div className="text-center">
              <Link to="/progetti" data-testid="gallery-cta-progetti">
                <Button className="btn-shine bg-[#0B1E36] hover:bg-[#0B1E36]/90 text-white font-semibold px-8 py-6 rounded-full text-base group">
                  Vedi tutti i progetti
                  <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
            </div>
          </>
        )}
      </div>

      <ProgettoLightbox project={selected} onClose={() => setSelected(null)} />
    </section>
  );
}
